<template>
    <div>
        <div class="suppliesOrder">
            <div class="supplyOrder" v-for="(furniture, index) in furnitures">

                <input type="hidden" :name="'furnitures[' + index + '][id]'" v-model="furniture.id">
                <input type="hidden" :name="'furnitures[' + index + '][old_image]'" :value="furniture.image">

                <div class="row">
                  <!-- EN -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label :for="'name_en_' + furniture.id">
                          <slot name="name_en-label"></slot>
                      </label>
                      <input :name="'furnitures[' + index + '][name-en]'" v-model="furniture.name_en" :id="'name_en_' + furniture.id" type="text">
                    </div>

                    <div class="form-group">
                      <label :for="'description_en_' + furniture.id">
                          <slot name="description_en-label"></slot>
                      </label>
                      <textarea :name="'furnitures[' + index + '][description-en]'" v-model="furniture.description_en" :id="'description_en_' + furniture.id"></textarea>
                    </div>
                  </div><!--.col-md-6-->

                  <!-- FR -->
                  <div class="col-md-6">
                    <div class="form-group">
                        <label :for="'name_fr_' + furniture.id">
                            <slot name="name_fr-label"></slot>
                        </label>
                        <input :name="'furnitures[' + index + '][name-fr]'" v-model="furniture.name_fr" :id="'name_fr_' + furniture.id" type="text">
                    </div>

                    <div class="form-group">
                        <label :for="'description_fr_' + furniture.id">
                            <slot name="description_fr-label"></slot>
                        </label>
                        <textarea :name="'furnitures[' + index + '][description-fr]'" v-model="furniture.description_fr" :id="'description_fr_' + furniture.id"></textarea>
                    </div>
                  </div><!--.col-md-6-->
                </div><!--.row-->

                <file-uploader :name="'furnitures[' + index + '][image]'" accept=".svg, .png, .jpg"
                               :stored="furniture.image"
                               :label="labelUpload"
                               :label-switch="labelSwitch"
                               :show="furniture.image != null"
                               :element-id="+furniture.id"
                               @pictureChanged="onPictureChanged"
                ></file-uploader>

                <div class="row">

                  <div class="col-md-6">
                    <div class="form-group">
                      <label :for="'ref_' + furniture.id">
                          <slot name="reference-label"></slot>
                      </label>
                      <input :name="'furnitures[' + index + '][reference]'" v-model="furniture.reference" :id="'ref_' + furniture.id" type="text">
                    </div>
                  </div><!--.col-md-6-->

                  <div class="col-md-6">
                    <div class="form-group">
                      <label :for="'price_' + furniture.id">
                          <slot name="price-label"></slot>
                      </label>
                      <input :name="'furnitures[' + index + '][price]'" type="number" v-model="furniture.price" :id="'price_' + furniture.id">
                    </div>
                  </div><!--.col-md-6-->


                  <div v-if="showStartupFields" class="col-md-6">
                    <div class="form-group">
                      <label :for="'default_quantity_' + furniture.id">
                          <slot name="default_quantity-label"></slot>
                      </label>
                      <input :name="'furnitures[' + index + '][default_quantity]'" type="number" v-model="furniture.default_quantity" :id="'default_quantity_' + furniture.id">
                    </div>
                  </div><!--.col-md-6-->

                <div class="col-md-6">
                  <div class="form-group">
                    <label :for="'available_day_quantity_' + furniture.id">
                        <slot name="available_day_quantity-label"></slot>
                    </label>
                    <input :name="'furnitures[' + index + '][available_day_quantity]'" type="number" v-model="furniture.available_day_quantity" :id="'available_day_quantity_' + furniture.id" >
                  </div>
                </div><!--.col-md-6-->
              </div><!--.row-->

                <button type="button" class="btn-medium-grey supplyOrder__delete mt-4" @click="deleteFurniture(index)">
                    <slot name="delete-label"></slot>
                </button>

            </div>
        </div>

        <div>
            <button type="button" class="btn-blue" @click="addFurniture">
                <slot name="add-label"></slot>
            </button>
        </div>
    </div>
</template>

<script>
    import FileUploader from "./FileUploader";

    export default {
        components: {
            'file-uploader': FileUploader
        },
        props: {
            labelUpload: {
                type: String,
                default: 'Ajouter un fichier'
            },
            labelSwitch: {
                type: String,
                default: 'Remplacer le fichier'
            },
            oldFurnitures: {
                type: Array,

                default: () => [
                    {
                        image: null,
                        name_en: '',
                        name_fr: '',
                        description_en: '',
                        description_fr: '',
                        price: 0,
                        available_day_quantity: 0,
                        default_quantity: 0,
                        reference: '',
                        id: -1
                    }
                ]
            },
            showStartupFields: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                furnitures: this.oldFurnitures
            }
        },
        methods: {
            addFurniture() {
                this.furnitures.push({
                    image: null,
                    name_en: '',
                    name_fr: '',
                    description_en: '',
                    description_fr: '',
                    price: 0,
                    available_day_quantity: 0,
                    default_quantity: 0,
                    reference: '',
                    id: -1
                });
            },
            deleteFurniture(index) {
                this.furnitures.splice(index, 1);
                if (this.furnitures.length === 0) {
                    this.addFurniture();
                }
            },
            onPictureChanged(event) {
                this.furnitures.forEach((furniture) => {
                    if (furniture.id == event[0]) {
                        furniture.image = event[2];
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
